import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useUiStore = create(
  persist(
    (set) => ({
      globalSearchOpen: false,
      shortcutHelpOpen: false,
      fastActionOpen: false,
      batchMode: false,
      sidebarCollapsed: false,
      sidebarMode: 'daily',
      headerToolsOpen: false,
      herdContextExpanded: false,
      preferencesSyncState: 'idle',
      lastPreferencesSyncAt: '',
      setGlobalSearchOpen: (globalSearchOpen) => set({ globalSearchOpen: !!globalSearchOpen }),
      setShortcutHelpOpen: (shortcutHelpOpen) => set({ shortcutHelpOpen: !!shortcutHelpOpen }),
      setFastActionOpen: (fastActionOpen) => set({ fastActionOpen: !!fastActionOpen }),
      setBatchMode: (batchMode) => set({ batchMode: !!batchMode }),
      setSidebarCollapsed: (sidebarCollapsed) => set({ sidebarCollapsed: !!sidebarCollapsed }),
      setSidebarMode: (sidebarMode) => set({ sidebarMode: sidebarMode === 'all' ? 'all' : 'daily' }),
      setHeaderToolsOpen: (headerToolsOpen) => set({ headerToolsOpen: !!headerToolsOpen }),
      setHerdContextExpanded: (herdContextExpanded) => set({ herdContextExpanded: !!herdContextExpanded }),
      setPreferencesSyncState: (preferencesSyncState) => set({ preferencesSyncState: preferencesSyncState || 'idle' }),
      setLastPreferencesSyncAt: (lastPreferencesSyncAt) => set({ lastPreferencesSyncAt: lastPreferencesSyncAt || '' }),
      resetPowerUserState: () => set({ batchMode: false, headerToolsOpen: false }),
    }),
    {
      name: 'ui-storage',
      partialize: (state) => ({
        batchMode: state.batchMode,
        sidebarCollapsed: state.sidebarCollapsed,
        sidebarMode: state.sidebarMode,
        herdContextExpanded: state.herdContextExpanded,
        lastPreferencesSyncAt: state.lastPreferencesSyncAt,
      }),
    }
  )
);

export default useUiStore;
